// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProactiveMainTab_wrapper__34zNI","wrapper__button":"ProactiveMainTab_wrapper__button__90Ng7","allowProactive":"ProactiveMainTab_allowProactive__3mRi-"};